import { graphql } from "@/api/graphql/types/gql";

export const GetLedgerModificationDataQuery = graphql(`
  query GetEditableLedgerCreationTemplate(
    $request: LedgersMsGetLedgerModificationDataRequest!
  ) {
    LedgersMsGetLedgerModificationData(request: $request) {
      rawFormData
      isUnavailable
      category
    }
  }
`);
